import { useTranslation } from 'react-i18next'
import { Card } from '~/shared/ui'

interface ShippingOrderCommentsProps {
  comments: string[]
}

export const ShippingOrderComments = ({
  comments,
}: ShippingOrderCommentsProps) => {
  const { t } = useTranslation(['common', 'delivery'])

  if (comments.length === 0) {
    return null
  }

  return (
    <Card>
      <span className="text-[24px] text-[#242424]">
        {t('delivery:orderComments')}
      </span>
      {comments.map((comment, index) => (
        <div
          key={index}
          className="flex flex-col p-2 mt-2 bg-[#D1ECF1] rounded-lg"
        >
          {comment.split('\n').map((line, lineIndex) => (
            <span key={lineIndex}>{line}</span>
          ))}
        </div>
      ))}
    </Card>
  )
}
